<template lang="pug">
include ../Bemto
+b.auth-modal.moderation-modal
  row(
    appearance="spaced"
    justify="center"
  )
    cell(cols="12" style="margin: 0")
      row(
        appearance="spaced"
        justify="center"
      )
        cell(cols="narrow")
          +b.IMG.block.ma--t-sm(
            width="64"
            src="/static/img/raising-hands.png"
          )
    cell(style="margin: 0")
      +b.P.text.--align-center.--weight-bold.--size-lg-sm.--color-black.--font-serif.ma--t-2sm.moderation-modal_title {{ _('Вітаю, особистий кабінет створено!') }}
    cell(style="margin: 0")
      +b.P.text.--font-serif.--align-center.--size-sm.--color-dark-gray.ma--t-2xxs.ma--b-xss.moderation-modal_subtitle(style="margin-top: 8px") {{ _('Твоя анкета буде доступна для замовників пiсля додавання кастинг-директором фото та відео, які ми зробимо в нашій студії.') }}
    cell(style="margin: 0")
      +b.P.text.--align-center.--size-sm.--color-dark-gray.ma--t-2xs.ma--b-sm.moderation-modal_subtitle(style="margin-top: 24px; margin-bottom: 0") {{ _('Переглянути свою анкету, додати свої фото, посилання на свої соціальні мережі можна вже зараз в особистому кабінеті.') }}
    cell(style="margin: 0; max-width: 200px; width: 100%")
      //- +b.P.text.--align-center.--size-sm.--color-dark-gray.ma--t-2xs.ma--b-lg {{ _('Переглянути свою анкету, додати свої фото, посилання на свої соціальні мережі можна вже зараз в особистому кабінеті.') }}
      +b.A.el-btn.--default.ma--b-lg.cabinet-button(
        href="/auth/login/"
      )
        +b.P.text.--color-white.--space-lg.--size-1sm.--transform-upper.--weight-bold {{ _('До кабінету') }}
  +b.close-modal(
    @click.prevent='$emit("close")'
  )
    +b.APP-ICON(name="icon-cross")
</template>

<script>

// import ChatBotModal from '@app/modals/ChatBotModal'

export default {
  // mounted() {
  //   this.$once('hook:beforeDestroy', () => {
  //     this.$modal.show(ChatBotModal)
  //   })
  // },
  methods: {
    close() {
      this.$emit('close');
    },
  },
}
</script>
<style lang="scss">
.moderation-modal {
  max-width: 440px;
  margin: 0 auto;

  &_title {
    font-family: Open Sans;
    font-weight: 700;
    font-size: 18px;
    line-height: 23px;
  }

  &_subtitle {
    font-family: Open Sans;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;

  }
}

.cabinet-button {
  margin-top: 40px;
  margin-bottom: 0;

  p {
    font-family: Open Sans;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0;

    text-transform: none;
  }
}
</style>
<style>
.vm--modal {
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>
